import {FormView} from '@src/components/_views/configurable/FormView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import MaterialForm from './MaterialForm';

export class MaterialUpdateForm extends FormView {
    protected getFormComponent() {
        return MaterialForm;
    }
}

export default MaterialUpdateForm.getStoreConnector()(withRouterApi<FormViewProps>(MaterialUpdateForm));
